import React from 'react';
import { Bets } from '@alien-platform/bo-core';

import { Row } from '@/types/general';
import { HorizontalTable } from '@/components/core/horizontal-table';

export function StatusUpdateTable({ betData }: { betData: Bets }): React.JSX.Element {
  const statusData: Row[] = [
    {
      label: {
        text: 'Approved By',
      },
      value: {
        text: ``,
      },
    },
    {
      label: {
        text: 'Approved Date',
      },
      value: {
        text: ``,
      },
    },
    {
      label: {
        text: 'Main Status',
      },
      value: {
        text: betData.status,
      },
    },
    {
      label: {
        text: 'New Status',
      },
      value: {
        text: ``,
      },
    },
  ];

  return <HorizontalTable header="Status Update" tableData={statusData} />;
}
